import CbSteps from './src/steps.vue';

CbSteps.install = function(Vue) {
  Vue.component(CbSteps.name, CbSteps);
};

export default CbSteps;
